import { useState } from "react";
import { Controller } from "react-hook-form";
import { Autocomplete, TextField } from "@mui/material";

export function VehicleEquipmentSection({
  control,
  formState,
  editButton,
  facilities,
  onDotariChange,
}) {
  const [open, setOpen] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "blur") {
      setOpen(false);
    }
  };

  return (
    <Controller
      name="dotari"
      control={control}
      render={({ field: { value, onChange, ...field } }) => (
        <Autocomplete
          {...field}
          id="dotari"
          multiple
          open={open}
          defaultValue={formState?.defaultValues?.dotari}
          onOpen={() => setOpen(true)}
          onClose={handleClose}
          getOptionLabel={(option) => option?.nume}
          onChange={(e, item) => {
            onDotariChange(item);
          }}
          disabled={editButton}
          options={facilities}
          required
          ListboxProps={{
            sx: {
              display: "grid !important",
              gridTemplateColumns: "1fr 1fr 1fr",
            },
          }}
          isOptionEqualToValue={(option, value) => option?.nume == value?.nume}
          sx={{ margin: "10px" }}
          renderInput={(params) => <TextField label="Dotari" type="search" {...params} />}
        />
      )}
    />
  );
}

export default VehicleEquipmentSection;
